export default __webpack_public_path__ + "static/media/scrum.873b4084.svg";